import React from "react";
import { Box, Typography } from "@mui/material";
import { BILLING_ANNUAL, BILLING_MONTHLY } from "./plans";

export default function BillingCycleToggle({ value, onChange }) {
  const isAnnual = value === BILLING_ANNUAL;

  return (
    <Box
      data-testid="pricing-billing-toggle"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        px: 1.25,
        py: 0.75,
        borderRadius: "999px",
        bgcolor: "#F6F4FF",
        border: "1px solid rgba(74, 44, 245, 0.12)",
      }}
    >
      <Typography
        sx={{
          fontSize: 12.5,
          fontWeight: isAnnual ? 500 : 700,
          color: isAnnual ? "#8692A6" : "#111827",
          pl: 0.5,
        }}
      >
        Monthly
      </Typography>

      <Box
        component="button"
        type="button"
        role="switch"
        aria-checked={isAnnual}
        aria-label="Annual billing"
        data-testid="pricing-billing-switch"
        onClick={() => onChange(isAnnual ? BILLING_MONTHLY : BILLING_ANNUAL)}
        sx={{
          width: 40,
          height: 22,
          borderRadius: 999,
          border: "none",
          p: 0,
          cursor: "pointer",
          bgcolor: isAnnual ? "#4A2CF5" : "#C4B5FD",
          position: "relative",
          transition: "background-color 160ms ease",
          flexShrink: 0,
          "&:focus-visible": {
            outline: "2px solid #4A2CF5",
            outlineOffset: 2,
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 2,
            left: isAnnual ? 20 : 2,
            width: 18,
            height: 18,
            borderRadius: "50%",
            bgcolor: "#FFFFFF",
            boxShadow: "0 1px 3px rgba(17, 24, 39, 0.2)",
            transition: "left 160ms ease",
          }}
        />
      </Box>

      <Typography
        sx={{
          fontSize: 12.5,
          fontWeight: isAnnual ? 700 : 500,
          color: isAnnual ? "#111827" : "#8692A6",
          pr: 0.5,
        }}
      >
        Annual
      </Typography>
    </Box>
  );
}
